export const FormatTypes = {
  ASCII: 'ascii',
  BINARY: 'binary',
  APPENDED: 'appended',
};

export const TYPED_ARRAY = {
  Int8Array: 'Int8',
  Uint8Array: 'UInt8',
  Int16Array: 'Int16',
  Uint16Array: 'UInt16',
  Int32Array: 'Int32',
  Uint32Array: 'UInt32',
  Float32Array: 'Float32',
  Float64Array: 'Float64',
};

export default {
  FormatTypes,
};
